module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-neutral-026-1200x2490.c3fdab9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-neutral-026-1200x2490.jpg
// module id = 1109
// module chunks = 37